"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _secKill = require("@/api/activity/secKill");
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _ActivityQrcodeDialog = _interopRequireDefault(require("@/components/ActivityQrcodeDialog"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SecKillTablePane',
  components: {
    Pagination: _Pagination.default,
    ActivityQrcodeDialog: _ActivityQrcodeDialog.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      list: [],
      total: 0,
      resPath: process.env.VUE_APP_IMAGE_PATH,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 20,
        title: ''
      },
      qrcodeDialogVisible: false,
      qrItems: [],
      qrTitle: ''
    };
  },
  created: function created() {
    this.fetchData();
  },
  methods: {
    // 兼容三种存储格式：完整URL、旧格式(/images/mall/xxx.jpg)、新格式(xxx.jpg)
    // 与编辑/创建时的图片回显逻辑保持一致（参考 SecKillConfig.vue getDisplayUrl）
    getImageUrl: function getImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = this.resPath || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    fetchData: function fetchData() {
      var _this = this;
      this.listLoading = true;
      (0, _secKill.getSecKillList)(this.listQuery).then(function (response) {
        var records = response.records || [];
        _this.list = records;
        _this.total = response.total || 0;
        _this.listLoading = false;
      }).catch(function (error) {
        console.error('获取秒杀活动列表失败:', error);
        _this.listLoading = false;
        _this.list = [];
        _this.total = 0;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.fetchData();
    },
    handlePagination: function handlePagination() {
      this.fetchData();
    },
    handleCreate: function handleCreate() {
      this.$emit('toSecKillConfig', null);
    },
    handleUpdate: function handleUpdate(row) {
      this.$emit('toSecKillConfig', row.id);
    },
    handleCopy: function () {
      var _handleCopy = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2(row) {
        var _this2 = this;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (!(!row || !row.id)) {
                _context2.next = 1;
                break;
              }
              this.$message.warning('无法复制：数据异常');
              return _context2.abrupt("return");
            case 1:
              this.$confirm('确定要一键复制此秒杀活动吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var response, _t;
                return regeneratorRuntime.wrap(function (_context) {
                  while (1) switch (_context.prev = _context.next) {
                    case 0:
                      _context.prev = 0;
                      _context.next = 1;
                      return (0, _secKill.copySecKill)(row.id);
                    case 1:
                      response = _context.sent;
                      if (response.code === 200) {
                        _this2.$message.success('复制成功');
                        _this2.fetchData();
                      } else {
                        _this2.$message.error(response.message || '复制失败');
                      }
                      _context.next = 3;
                      break;
                    case 2:
                      _context.prev = 2;
                      _t = _context["catch"](0);
                      _this2.$message.error('复制失败：' + _t.message);
                    case 3:
                    case "end":
                      return _context.stop();
                  }
                }, _callee, null, [[0, 2]]);
              }))).catch(function () {});
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function handleCopy(_x) {
        return _handleCopy.apply(this, arguments);
      }
      return handleCopy;
    }(),
    handleQrcode: function handleQrcode(row) {
      if (!row || !row.id) {
        this.$message.warning('无法生成二维码：数据异常');
        return;
      }

      // 秒杀活动页点餐端、社区端均展示
      this.qrItems = [{
        label: '点餐端',
        url: "".concat(process.env.VUE_APP_ACTIVITY_URL, "/secKill/").concat(row.id)
      }, {
        label: '社区端',
        url: "".concat(process.env.VUE_APP_COMMUNITY_URL, "/secKill/").concat(row.id)
      }];
      this.qrTitle = row.title || '秒杀活动';
      this.qrcodeDialogVisible = true;
    },
    handleOrder: function handleOrder(row) {
      if (!row || !row.id) {
        this.$message.warning('数据异常');
        return;
      }
      this.$emit('toSecKillOrder', {
        id: row.id,
        title: row.title
      });
    },
    handleRefund: function handleRefund(row) {
      if (!row || !row.id) {
        this.$message.warning('数据异常');
        return;
      }
      this.$emit('toSecKillRefund', {
        id: row.id,
        title: row.title
      });
    },
    handleToggleStatus: function handleToggleStatus(row) {
      var _this3 = this;
      (0, _secKill.toggleSecKillStatus)(row.id, row.enabled).then(function () {
        _this3.$message.success('状态更新成功');
      }).catch(function () {
        row.enabled = row.enabled === 1 ? 0 : 1;
      });
    }
  },
  filters: {
    formatDate: function formatDate(time) {
      if (!time) return '';
      var date = new Date(time);
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, '0');
      var day = String(date.getDate()).padStart(2, '0');
      var hours = String(date.getHours()).padStart(2, '0');
      var minutes = String(date.getMinutes()).padStart(2, '0');
      var seconds = String(date.getSeconds()).padStart(2, '0');
      return "".concat(year, "-").concat(month, "-").concat(day, " ").concat(hours, ":").concat(minutes, ":").concat(seconds);
    }
  }
};